// Shared existing day/league display conversion. Keep both views on the same time basis.
export function getGermanFixtureDate(
    startingAt
  ) {
    if (!startingAt) {
      return null;
    }

    const startingText =
      String(
        startingAt
      );

    const offsetMatch =
      startingText.match(
        /([+-]\d{2}):?(\d{2})?$/
      );

    let offsetHours = 2;

    if (offsetMatch) {
      offsetHours =
        parseInt(
          offsetMatch[1],
          10
        );
    }

    const baseDate =
      new Date(
        startingAt
      );

    if (
      Number.isNaN(
        baseDate.getTime()
      )
    ) {
      return null;
    }

    return new Date(
      baseDate.getTime() +
        offsetHours *
          60 *
          60 *
          1000
    );
  }
